import type { EventDialInInformation, EventParticipantRole } from 'models';
import { useMemo } from 'react';

export const useGetDialInHrefEvent = ({
  dialInInformation,
  role,
}: {
  dialInInformation?: EventDialInInformation;
  role?: EventParticipantRole;
}) =>
  useMemo(() => {
    if (!dialInInformation || !role) {
      return null;
    }

    const usePresenterDialIn =
      ['moderator', 'presenter'].includes(role) &&
      dialInInformation.presenterId &&
      dialInInformation.presenterNumber &&
      dialInInformation.presenterPasscode;

    const id = usePresenterDialIn ? dialInInformation.presenterId : dialInInformation.id;
    const number = usePresenterDialIn ? dialInInformation.presenterNumber : dialInInformation.number;
    const passcode = usePresenterDialIn ? dialInInformation.presenterPasscode : dialInInformation.passcode;

    if (!id || !number || !passcode) {
      return null;
    }

    return {
      href: `tel:${number};;${id};;${passcode}`,
      id,
      number,
      passcode,
    };
  }, [dialInInformation, role]);
